import React, { useState, useContext } from 'react'

//components
import StoreCashTable from './StoreCashTable'
import CashRegisterTabHeader from '../CashRegisterTabHeader'
import CashRegisterTabsContent from '../CashRegisterTabsContent'
import StoreCashDrawer from './StoreCashDrawer'
import cashRegisterSrc from '../../cashRegisterSrc'

// Context
import { Context } from '../../../../context'

function StoreCashTab(props) {
  const [state, dispatch] = useContext(Context)
  const [adjust, setAdjust] = useState({})
  const [showDrawer, setShowDrawer] = useState(false)
  const [loading, setLoading] = useState(false)
  const [fetch, setFetch] = useState(true)

  const onAdjust = data => {
    setAdjust(data)
    setShowDrawer(true)
  }

  const getCash = id => {
    setShowDrawer(false)
    setLoading(true)

    cashRegisterSrc.getStore(id).then(response => {
      dispatch({
        type: 'TURN CASH',
        payload: response.data.data[0],
      })
      setFetch(true)
      setLoading(false)
    })
  }

  return (
    <div>
      <CashRegisterTabHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => {
          props.setSelectedOption(option)
        }}
        search={false}
        turn={state.turn}
      />
      <CashRegisterTabsContent
        loading={loading}
        component={StoreCashTable}
        selectedOption={props.selectedOption}
        onAdjust={onAdjust}
        turn={state.turn}
        adjust={true}
        fetch={fetch}
      />
      <StoreCashDrawer
        closable={(type, storeId) => {
          if (type === 'save') getCash(storeId)
          else setShowDrawer(false)
        }}
        setFetch={setFetch}
        visible={showDrawer}
        adjust={adjust}
      />
    </div>
  )
}

export default StoreCashTab
